module.exports = __webpack_public_path__ + "static/img/home-new1.b48bf26f.jpeg";